module.exports = __webpack_public_path__ + "img/V supino.892ab022.png";